import { useTranslation } from 'react-i18next';
import { DiscountStatuses } from '../../../types/enums';

interface GetVIPCOdeErrorMessagesArgs {
  status?: DiscountStatuses;
  productNames?: string[];
  delegateTypesNames?: string[];
}

export function useGetVIPCodeErrorMessages() {
  const { t } = useTranslation();

  function getVIPCodeErrorMessage(args: GetVIPCOdeErrorMessagesArgs) {
    const { status, productNames = [], delegateTypesNames = [] } = args;

    switch (status) {
      case DiscountStatuses.NO_CODE_EXISTS:
        return t(
          'site.pricing.discount.vip-code.validation.NO_CODE_EXISTS.message',
        );
      case DiscountStatuses.CODE_EXPIRED:
        return t(
          'site.pricing.discount.vip-code.validation.CODE_EXPIRED.message',
        );
      case DiscountStatuses.MAX_CLAIMS_REACHED:
        return t(
          'site.pricing.discount.vip-code.validation.MAX_CLAIMS_REACHED.message',
        );
      case DiscountStatuses.CODE_IS_AVAILABLE_ONLY_FOR_PRODUCTS:
        return t(
          'site.pricing.discount.vip-code.validation.CODE_IS_AVAILABLE_ONLY_FOR_PRODUCTS.message',
          {
            0: productNames.join(', '),
          },
        );
      case DiscountStatuses.CODE_IS_AVAILABLE_ONLY_FOR_DELEGATE_TYPES:
        return t(
          'site.pricing.discount.vip-code.validation.CODE_IS_AVAILABLE_ONLY_FOR_DELEGATE_TYPES.message',
          {
            0: delegateTypesNames.join(', '),
          },
        );
      case DiscountStatuses.CODE_IS_AVAILABLE_ONLY_FOR_DELEGATE_TYPES_AND_FOR_PRODUCTS:
        return t(
          'site.pricing.discount.vip-code.validation.CODE_IS_AVAILABLE_ONLY_FOR_DELEGATE_TYPES_AND_FOR_PRODUCTS.message',
          {
            0: delegateTypesNames.join(', '),
            1: productNames.join(', '),
          },
        );
      case DiscountStatuses.CODE_IS_DISABLED_FOR_EARLY_BIRD:
        return t(
          'site.pricing.discount.vip-code.form.field.validation.CODE_IS_DISABLED_FOR_EARLY_BIRD.message',
        );
      default:
        return t(
          'site.pricing.discount.vip-code.form.field.validation.NOT_FOUND.message',
        );
    }
  }

  return { getVIPCodeErrorMessage };
}
